<script setup lang="ts">
import {HomeSurveyAnswerInstanceItem} from "@/home/interfaces";
import HomeLiveItem from "@/home/components/HomeLiveItem.vue";
import {useRouter} from "vue-router";
import {SurveyAnswerInstance} from "@/core/interfaces/survey/Survey";
import ConsumerKeyService from "@/consumer/services/ConsumerKeyService";
import {useLiveStore} from "@/stores/live.store";
import {LiveItemType} from "@/core/interfaces/live/LiveItem";

const router = useRouter();
const {updateItem} = useLiveStore();
defineProps<{
    item: HomeSurveyAnswerInstanceItem['data']
}>();

/**
 * Redirect to the interview instance view.
 */
const goToInstance = (instance: SurveyAnswerInstance) => {
    if (instance?.consumer_key) {
        const customerId = ConsumerKeyService.customerIdFromKey(instance.consumer_key);
        if (customerId) {
            updateItem(instance.id, LiveItemType.SURVEY_ANSWER_INSTANCE)
                .then(() => router.push({
                    name: 'customer.survey',
                    params: {customerId: customerId, instanceId: instance.id}
                }));
        }
    } else {
        updateItem(instance.id, LiveItemType.SURVEY_ANSWER_INSTANCE)
            .then(() => router.push({
                name: 'uncertified.survey-built',
                params: {instanceId: instance.id}
            }));
    }
};
</script>

<template>
  <HomeLiveItem
    :at="item?.completed_at ?? 'Questionnaire incomplet'"
    @click="goToInstance(item)"
  >
    <template #image>
      <div class="w-full">
        <img
          alt="Survey"
          width="100%"
          src="@/assets/icons/survey.svg"
          class="w-[90%] object-contain"
        >
      </div>
    </template>
    <p v-if="item?.filler" class="font-semibold">
      {{ item.filler.name }}
    </p>
    <p class="line-clamp-1">
      Résultat questionnaire : {{ item.survey?.theme || item.survey.name }}
    </p>
  </HomeLiveItem>
</template>
